import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { staticDataTypeLabelQueries } from '@/services/staticDataTypeLabel/staticDataTypeLabel.queries';

export const useStaticDataTypeLabelDetail = (staticDataLabelId?: string) => {
  const { data, isLoading } = useQuery({
    ...staticDataTypeLabelQueries.details(staticDataLabelId ?? ''),
    enabled: Boolean(staticDataLabelId),
  });

  return { staticDataLabel: data?.data, isLoading };
};
